// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"173":"36674f48","727":"366e72e5"}[chunkId] + ".chunk.js";
};